module.exports = __webpack_public_path__ + "img/Aktobe.87c767dc.png";